export default __webpack_public_path__ + "static/media/ary-home.b1e3d2cd.jpg";